/* eslint-disable no-unused-vars */
import React from "react"
import { v4 as uuidv4 } from "uuid"

import SectionOutputDivisionModal from "./SectionOutputDivisionModal"
import SectionOutputPercentageModal from "./SectionOutputPercentageModal"
import SectionOutputDetails from "./SectionOutputDetails"
import SectionOutputsIngredientsDialog from "./SectionOutputsIngredientsDialog"
import { findObjectByPathValue } from "../../../../../utils"
import { removeStepComponent, updateStepComponent } from "../../../../../utils/stepComponentUtils"
import { getSectionOutputsData, updateRecipeOnChangeSectionOutput } from "../../../../../utils/sectionUtils"


const SectionOutput = ({ open, onClose, recipe, section, sectionIndex, setFieldValue, onOpen, isEdition }) => {
  const [step, setStep] = React.useState(null) //division, percentage, ingredients
  const [divisionType, setDivisionType] = React.useState(section.sectionOutputs && section.sectionOutputs.length > 0 ? section.sectionOutputs[0].type : null) //percentage, ingredients

  React.useEffect(() => {
    setStep(open ? "division" : null)
  }, [open])

  const handleSetDivisionType = (value) => {
    setStep(value)
    setDivisionType(value)
  }
  const handleClosePercentage = () => {
    setStep("division")
    setDivisionType(null)
  }

  const onBeforeClearSectionOutputs = () => {
    const previousOutputs = section.sectionOutputs || []
    const removedOutputsIndexes = previousOutputs.map(ro => ro.index)
    previousOutputs.forEach(sOutput => {
      const [usedSectionOutput] = findObjectByPathValue(recipe, "sections.productionSteps.step.stepComponents.sectionOutput.index", sOutput.index, { path: true })
      if (usedSectionOutput) {
        const [componentIndex, indexStep, sectionIndex] = usedSectionOutput.path.match(/\d+/g).map(Number)
        const oldSc = recipe.sections[sectionIndex].productionSteps[indexStep].step.stepComponents[componentIndex]
        if (removedOutputsIndexes.includes(sOutput.index)) removeStepComponent(recipe, oldSc, setFieldValue)
      }
    })
  }

  const handleChangeSectionOutputs = (values) => {
    const newSectionOutputs = values.sectionOutputs.map(output => ({
      ...output,
      index: output?.index ?? uuidv4(),
    }))

    const isSameType = newSectionOutputs[0]?.type === (section.sectionOutputs && section.sectionOutputs.length > 0 ? section.sectionOutputs[0].type : null)
    if (!isSameType) {
      onBeforeClearSectionOutputs()
    }

    setFieldValue(`sections.${sectionIndex}.sectionOutputs`, newSectionOutputs)
    updateRecipeOnChangeSectionOutput({
      ...recipe,
      sections: recipe.sections.map((sct, sctIndex) => sctIndex === sectionIndex ? { ...section, sectionOutputs: newSectionOutputs } : sct)
    },
      {
        ...recipe.sections[sectionIndex],
        sectionOutputs: newSectionOutputs
      }
    )
    onClose()
  }

  const handleCloseSectionOutputsByIngredients = () => {
    setStep("division")
    setDivisionType(null)
  }

  const handleDeleteSectionOutputs = () => {
    onBeforeClearSectionOutputs()
    setFieldValue(`sections.${sectionIndex}.sectionOutputs`, [])
  }


  return (
    <>
      <SectionOutputDetails isEdition={isEdition} section={section} onDelete={handleDeleteSectionOutputs} onEdit={onOpen} />
      <SectionOutputDivisionModal
        open={step === "division"}
        onClose={onClose}
        divisionType={divisionType}
        setDivisionType={handleSetDivisionType}
        section={section}
      />
      <SectionOutputPercentageModal
        open={step === "percentage"}
        onClose={handleClosePercentage}
        onSubmit={handleChangeSectionOutputs}
        section={section}
      />
      <SectionOutputsIngredientsDialog
        onClose={handleCloseSectionOutputsByIngredients}
        open={step === "ingredient"}
        section={section}
        onSubmit={handleChangeSectionOutputs}
      />
    </>
  )
}
export default SectionOutput